import { useState } from "react";

export function useFormValidation(action) {
  const [titleError, setTitleError] = useState("");
  const [eventFormatError, setEventFormatError] = useState("");
  const [localizationError, setLocalizationError] = useState("");
  const [dateStartError, setDateStartError] = useState("");
  const [dateEndError, setDateEndError] = useState("");
  const [hourStartError, setHourStartError] = useState("");
  const [hourEndError, setHourEndError] = useState("");
  const [productsError, setProductsError] = useState("");

  const validate = ({
    title,
    selectedGroup,
    localizationSelected,
    startDate,
    endDate,
    startHour,
    endHour,
    productsSelected,
  }) => {
    setTitleError("");
    setEventFormatError("");
    setLocalizationError("");
    setDateStartError("");
    setDateEndError("");
    setHourStartError("");
    setHourEndError("");
    setProductsError("");

    const isValidDate = (d) => d && d !== "";
    const isValidTime = (t) => t && t !== "";

    const hasStartDate = isValidDate(startDate);
    const hasEndDate = isValidDate(endDate);
    const hasStartHour = isValidTime(startHour);
    const hasEndHour = isValidTime(endHour);

    const startDateTime =
      hasStartDate && hasStartHour
        ? new Date(`${startDate}T${startHour}`)
        : null;

    const startWithEndHourDateTime =
      hasStartDate && hasEndHour ? new Date(`${startDate}T${endHour}`) : null;

    const endDateTime =
      hasEndDate && hasEndHour ? new Date(`${endDate}T${endHour}`) : null;

    if (!title || title.trim() === "") {
      setTitleError("O campo Nome é obrigatório.");
      return false;
    }

    if (!selectedGroup || selectedGroup === "Selecionar") {
      setEventFormatError("Selecione o formato do evento");
      return false;
    }

    if (selectedGroup !== "digital" && !localizationSelected) {
      setLocalizationError("Insira um local");
      return false;
    }

    if (!hasStartDate) {
      setDateStartError("O campo Data de Início é obrigatório.");
      return false;
    }

    if (hasEndDate && hasStartDate && endDate < startDate) {
      setDateEndError("A Data Fim não pode ser menor que a Data Inicio.");
      return false;
    }
    if (
      startDateTime &&
      !endDateTime &&
      hasEndHour &&
      startWithEndHourDateTime < startDateTime
    ) {
      setHourEndError("A hora fim não pode ser menor que a hora inicio.");
      return false;
    }

    if (startDateTime && endDateTime && endDateTime < startDateTime) {
      if (action === "create") {
        setDateEndError(
          "A Data e Hora Fim não pode ser menor que a Data e Hora Inicio."
        );
        return false;
      }
      if (action === "edit") {
        if (endHour !== "00:00") {
          setDateEndError(
            "A Data e Hora Fim não pode ser menor que a Data e Hora Inicio."
          );
          return false;
        }
      }
    }

    if (hasEndDate && hasStartDate && !hasStartHour && hasEndHour) {
      setHourStartError("O campo Hora Inicio deve ser informado.");
      return false;
    }
    if (hasStartDate && !hasEndDate && !hasStartHour && hasEndHour) {
      setHourStartError("O campo Hora Inicio deve ser informado.");
      return false;
    }

    if (!productsSelected || productsSelected.length === 0) {
      setProductsError("Selecione ao menos um produto");
      return false;
    }

    return true;
  };

  return {
    titleError,
    eventFormatError,
    localizationError,
    dateStartError,
    dateEndError,
    hourStartError,
    hourEndError,
    productsError,
    validate,
  };
}
